import LegalPage from "./LegalPage";

function TermsPage() {
  return (
    <LegalPage
      slug="terms"
      title="Terms of Service | Vocally"
      description="Review the terms of service for using Vocally's voice-first keyboard and transcription tools."
    />
  );
}

export default TermsPage;
